import { createReducer } from 'redux-act';

import { databasesLoaded } from './actions';

export default createReducer({
  [databasesLoaded]: (_state, databases) => databases,
}, []);
